import React, { useState, useEffect } from 'react';

interface VersionInfo {
  version: string;
  buildDate: string;
  buildNumber: string;
}

interface VersionDisplayProps {
  showBuildInfo?: boolean;
  className?: string;
}

const VersionDisplay: React.FC<VersionDisplayProps> = ({ 
  showBuildInfo = false, 
  className = "" 
}) => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);

  useEffect(() => {
    // Fetch version info from public folder
    fetch('/version.json')
      .then(response => {
        if (!response.ok) throw new Error('Version file not found');
        return response.json();
      })
      .then((data: VersionInfo) => {
        setVersionInfo(data);
      })
      .catch(() => {
        // Fallback version info for development
        setVersionInfo({
          version: '0.0.0-dev',
          buildDate: new Date().toISOString(),
          buildNumber: 'dev'
        });
      });
  }, []);

  if (!versionInfo) return <span className={className}>Loading...</span>;

  return (
    <span className={className} title={`Build Date: ${new Date(versionInfo.buildDate).toLocaleString()}`}>
      
      {showBuildInfo ? (<>
          {versionInfo.buildNumber}
          </>
      ) : <>{versionInfo.version}</>}
    </span>
  );
};

export { VersionDisplay };
export default VersionDisplay;